import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-stone-100"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="/"
            className={`text-xl md:text-2xl font-semibold tracking-tight transition-colors ${
              scrolled ? "text-stone-900" : "text-white"
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Purrfect Pinot Noir
          </a>

          <div className="hidden md:flex items-center gap-8">
            {[
              { label: "Product", href: "#product" },
              { label: "Features", href: "#features" },
              { label: "Reviews", href: "#reviews" },
              { label: "About", href: "#story" },
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`text-sm font-medium tracking-wide transition-colors hover:opacity-70 ${
                  scrolled ? "text-stone-700" : "text-white/90"
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <a
              href="#find-at-costco"
              className={`text-sm font-medium px-5 py-2.5 rounded-full transition-all whitespace-nowrap ${
                scrolled
                  ? "bg-stone-900 text-white hover:bg-stone-800"
                  : "bg-white/15 text-white backdrop-blur-sm hover:bg-white/25"
              }`}
            >
              Find at Costco
            </a>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i
              className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-xl ${
                scrolled ? "text-stone-900" : "text-white"
              }`}
            />
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 z-[60] bg-black/40" onClick={() => setMobileMenuOpen(false)}>
          <div className="bg-white w-full border-t border-stone-100 shadow-lg max-h-[calc(100vh-4rem)] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 py-6 flex flex-col gap-5">
              {[
                { label: "Product", href: "#product" },
                { label: "Features", href: "#features" },
                { label: "Reviews", href: "#reviews" },
                { label: "About", href: "#story" },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-base font-medium text-stone-800 py-2 border-b border-stone-100 pb-3"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#find-at-costco"
                className="mt-2 text-center text-sm font-medium px-5 py-3.5 rounded-full bg-stone-900 text-white whitespace-nowrap"
                onClick={() => setMobileMenuOpen(false)}
              >
                Find at Costco
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}